import { useState } from 'react';
import HomeHero from '../components/HomeHero';
import HomeAboutSection from '../components/HomeAboutSection';
import HomeDepartmentsSection from '../components/HomeDepartmentsSection';
import HomeBrandsSection from '../components/HomeBrandsSection';
import ContactModal from '../components/ContactModal';

const HomePage = ({ setCurrentPage, setDepartmentName }) => { // Recibe setDepartmentName
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <HomeHero setCurrentPage={setCurrentPage} />
      <HomeAboutSection setCurrentPage={setCurrentPage} />
      <HomeDepartmentsSection setCurrentPage={setCurrentPage} setDepartmentName={setDepartmentName} /> {/* Pasa setDepartmentName */}
      <HomeBrandsSection />
      
      {/* Sección Cotizar Ahora */}
      <section className="py-20 bg-gradient-to-r from-red-600 to-red-800 text-white text-center">
        <h2 className="text-4xl font-bold mb-6">¿Necesitas una cotización?</h2>
        <p className="text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
          Contáctanos directamente para obtener mas Información y las mejores soluciones para tus proyectos.
        </p>
        <button 
          onClick={() => setIsModalOpen(true)} 
          className="bg-white text-red-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-lg"
        >
          Cotizar Ahora
        </button>
      </section>

      {/* Modal de Contacto */}
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};
export default HomePage;